import { useCollection, type UseCollectionOptions } from '@/composables/useDataTableProps';
import { Ort, OrtCollection } from '@/models/Ort';
import type { QueryParams } from '@kp/js-model';
import type { Ref } from 'vue';

/**
 * Creates a reactive connection between a BaugemeindeCollection and its params.
 * @see useCollection for more information
 * @returns  an object with the reactive props for this collection, @see useCollection
 */

export function useOrtCollection(options: UseCollectionOptions = {}, queryParams: QueryParams = {}) {
    const ort = new OrtCollection();
    ort.setQueryParams(queryParams);
    const initialFilters: ApiFilter[] = [];

    const refs = useCollection(ort, {
        ...{
            tableSort: [],
            collectionsFilter: initialFilters,
            pageSize: 30
        },
        ...options
    });
    return refs;
}
